import { GetStaticPaths, GetStaticPropsContext } from 'next'
import { loadFallback } from 'utils'
import { SiteDomain } from 'types'
import { productRedirects } from 'homeRedirects'
import { environment } from '@config/environment'

/**
 * The page "product" is only responsible for redirecting to the new product pages.
 * It throws a 404 if no redirect mapping found or if the site is not furniture.
 */

export const getStaticPaths: GetStaticPaths = async () => {
  if (environment.siteDomain !== SiteDomain.FURNITURE) return { paths: [], fallback: false }

  return { paths: [], fallback: true }
}

export const getStaticProps = async ({ params }: GetStaticPropsContext<{ slug: string }>) => {
  const productSlug = params?.slug

  if (productSlug && productRedirects['/product/' + productSlug]) {
    const newUrl = productRedirects['/product/' + productSlug]

    return {
      redirect: {
        destination: newUrl,
        permanent: true,
      },
    }
  }

  return { notFound: true }
}

const Page = () => {
  return loadFallback()
}

export default Page
